import "./Footer.css";

import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";

import { Link } from "react-router-dom";


function Footer() {

  return (

    <footer className="footer">

      <div className="footer-container">


        {/* ==========================
            ABOUT
        ========================== */}

        <div className="footer-about">

          <h2>
            ABNB SEVA SAMITHI
          </h2>

          <p>
            ABNB Seva Samithi &amp; Vidya Charitable Trust
            is committed to supporting families through welfare
            programs, membership services, education assistance
            and transparent community development.
          </p>


          <div className="footer-social">

            <a
              href="/"
              onClick={(e) => e.preventDefault()}
            >
              <FaFacebookF />
            </a>

            <a
              href="/"
              onClick={(e) => e.preventDefault()}
            >
              <FaInstagram />
            </a>

            <a
              href="/"
              onClick={(e) => e.preventDefault()}
            >
              <FaYoutube />
            </a>

          </div>

        </div>


        {/* ==========================
            QUICK LINKS
        ========================== */}

        <div className="footer-column">

          <h3>
            Quick Links
          </h3>

          <Link to="/">
            Home
          </Link>

          <Link to="/about">
            About
          </Link>

          <Link to="/membership">
            Membership
          </Link>

          

          <Link to="/contact">
            Contact
          </Link>

        </div>


        {/* ==========================
            MEMBER SERVICES
        ========================== */}

        <div className="footer-column">

          <h3>
            Member Services
          </h3>

          <Link to="/register">
            Join Membership
          </Link>

          <Link to="/register">
            Member Login
          </Link>

          <Link to="/downloads">
            Download ID Card
          </Link>

          <Link to="/register">
            Claim Status
          </Link>

          <Link to="/downloads">
            Downloads
          </Link>

          <Link to="/contact">
            FAQs
          </Link>

        </div>


        {/* ==========================
            CONTACT
        ========================== */}

        <div className="footer-column">

          <h3>
            Contact Us
          </h3>

          <p>
            <FaPhone />
             +91 9490820051, 9490496040
          </p>

          <p>
            <FaEnvelope />
            info@abnbtrust.org
          </p>

          <p>
            <FaMapMarkerAlt />
            Guntur, Andhra Pradesh, India
          </p>

        </div>

      </div>


      {/* ==========================
          COPYRIGHT
      ========================== */}

      <div className="footer-bottom">

        © 2026 APNB Seva Samithi &amp; Vidya
        Charitable Trust. All Rights Reserved.

      </div>

    </footer>

  );
}

export default Footer;